import JSEncrypt from 'jsencrypt';
const NODE_ENV = process.env.REACT_APP_ENV;
const envConfig: string | undefined = process.env.NODE_ENV === 'development' ? 'test' : NODE_ENV; // 开发环境  和  发布环境

// 盒子开发、测试环境公钥：
const KEY1 = `MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDjhLZA5UygOJUI6WC5K2FVs0AsIzl0h6c5
 DqjsMHNQEeD3/n+RGi2DrYcGMWZOnsB/Qj6uoNVPXyE7JyNNMr4ERk1Zm5yMAFrKMJbM5K+c6NmZQu7xavyPLQ
 FVM9M0yTnV/9DDzDPKx3TPx9IIV8i2TEAeDA4n1g0p7lK/FyxdAwIDAQAB`;
// 准生产、生产环境公钥：
const KEY2 = `MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDAjCQvqNPnOZm6GVDqeOb5S2pJtbN3FMZ8
 vddW3B2f3jB0mf7vd1B+yjjfex2A5XVxr4YwAY/w4d1/m3v3Bn/qgAnLMKnpjeEwxQU3cU81eXAam4fMB+
 nlmC291quIuC0qFFL8YgT2bDjARsMRYbmKd6LTc58sKYeJD2MvkkOdKwIDAQAB`;
const PWDKEY1 = `MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCi2V+RVUYOGKlLEs/UWdAOqlpAgoNdGnMy7g51zKgyvMbsHYE/kyuB+C7nsbX0aHVGkxrjhiTU2rbslqYFdKenCqZtkpY2qyuurH5OYVSVO6tWKHGjZjgvrJyLd6rVw5HoaA8wPLl7FWo5jDnuNNoUyBcVlUYfRWuVP6yRaUgAjQIDAQAB`;
const PWDKEY2 = `MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDKuB+7dLm7htKIMdoABLzBJVbH0z+esdIHRFGnJUA9ZNBA8howCvb9I1fB363fHGTuDh1FGiSIIq/ZPSGk/agVReIFUbb02tt6I3tZwwjvau/AtE6ABngI6g+icq4jgvAqjpxHleCb+ctXUk4im3eZi2is3PqmCSmExUooBOSiXQIDAQAB`;
export const randomWord = (randomFlag: boolean, min: number, max: number) => {
  let str = '';
  let range = min;
  const arr = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
    '-',
    '.',
    '~',
    '!',
    '@',
    '#',
    '$',
    '%',
    '^',
    '&',
    '*',
    '(',
    ')',
    '_',
    ':',
    '<',
    '>',
    '?'
  ];

  if (randomFlag) {
    range = Math.round(Math.random() * (max - min)) + min; // 任意长度
  }
  for (let i = 0; i < range; i++) {
    const pos = Math.round(Math.random() * (arr.length - 1));
    str += arr[pos];
  }
  return str;
};

function base64ToBytes(base64String: any) {
  const binaryString = atob(base64String);
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes;
}

function bytesToHex(bytes: any) {
  return Array.prototype.map
    .call(bytes, function (byte) {
      return ('0' + (byte & 0xff).toString(16)).slice(-2);
    })
    .join('');
}

export const rsaEncode = (str: string) => {
  let KEY = '';
  if (envConfig === 'development' || envConfig === 'test') {
    KEY = KEY1;
  }
  if (envConfig === 'pre' || envConfig === 'production') {
    KEY = KEY2;
  }
  const encryptor = new JSEncrypt(); // 创建加密对象实例
  encryptor.setPublicKey(KEY); // 设置公钥
  let rsaPassWord: any = encryptor.encrypt(str); // 对内容进行加密
  rsaPassWord = base64ToBytes(rsaPassWord);
  rsaPassWord = bytesToHex(rsaPassWord);
  return rsaPassWord;
};
export const pwdRsaEncode = (str: string) => {
  let KEY = '';
  if (envConfig === 'development' || envConfig === 'test') {
    KEY = PWDKEY1;
  }
  if (envConfig === 'pre' || envConfig === 'production') {
    KEY = PWDKEY2;
  }
  const encryptor = new JSEncrypt(); // 创建加密对象实例
  encryptor.setPublicKey(KEY); // 设置公钥
  let rsaPassWord: any = encryptor.encrypt(str); // 对内容进行加密
  rsaPassWord = base64ToBytes(rsaPassWord);
  rsaPassWord = bytesToHex(rsaPassWord);
  return rsaPassWord;
};
